/**
 * Task #3585 — Helper base-path aware per la SPA master in DUAL MODE
 * (legacy sotto '/master/' sull'apex, root '/' sul sottodominio dedicato).
 * Pattern replicato da packages/frontend-w3.
 *
 * `import.meta.env.BASE_URL` è iniettato da Vite dal `base` di build:
 *   - '/master/' → BASE_PATH = '/master'
 *   - '/'        → BASE_PATH = ''
 *
 * NB: react-router (useLocation / basename) gestisce già il prefisso per la
 * navigazione interna. Questi helper servono SOLO per le URL assolute
 * same-origin (window.location.href) e per leggere window.location.pathname.
 */
export const BASE_PATH: string = import.meta.env.BASE_URL.replace(/\/$/, ''); // '' con base '/', '/master' con base '/master/'

/**
 * Prefissa un path SPA con il BASE_PATH corrente. Da usare per costruire
 * URL assolute same-origin (es. window.location.href = appPath('/login')).
 */
export function appPath(p: string): string {
  return `${BASE_PATH}${p}`;
}

/**
 * Toglie il prefisso BASE_PATH da un pathname assoluto (window.location.pathname),
 * restituendo il path "logico" della SPA. Il risultato non è mai vuoto
 * (fallback '/').
 */
export function stripBasePath(pathname: string): string {
  let result = pathname;
  if (BASE_PATH && result.startsWith(BASE_PATH)) {
    result = result.slice(BASE_PATH.length);
  }
  if (!result.startsWith('/')) {
    result = `/${result}`;
  }
  return result === '' ? '/' : result;
}
